<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import FixPanelIcon from "@/components/approval-center/partials/ui/FixPanelIcon.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import ModalTextAreaWrapper from "@/components/global-themed/ui/modals/ModalTextAreaWrapper.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import useApprovalFlow from "@/composables/approval-center/useApprovalFlow";
import {computed, ref, watch} from "vue";
import {successToast} from "@/composables/useToasts";
import {kitName} from "@/composables/useLocalDomains";

const {selectedApproval, handleRevisionHelpMutation} = useApprovalFlow();

const {mutate: helpMutate, isSuccess, isPending, error} = handleRevisionHelpMutation();

const validationError = computed(() => error?.value?.response?.data?.errors?.feedback[0]);

const feedback = ref('');

const triggerHelp = () => {
  helpMutate({
    approval: selectedApproval.value,
    feedback: feedback.value,
  })
}

watch(isSuccess, (value) => {
  if (value) {
    emit('close');
    successToast("I've sent your feedback to my manager for review. They'll get back to you shortly.")
  }
})

const emit = defineEmits(['close', 'confirm']);
</script>

<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[800px]"
      @close="emit('close')"
    >
      <ModalContentWrapper>
        <KitModalHeader>
          <KitIcon
            class="tw-w-[88px]"
            state="error"
          />

          <ModalHeader>
            <ModalHeading>Get Some Extra Help</ModalHeading>

            <ModalSubText>
              Tell us a bit more about what you were expecting, and we’ll pass your feedback to a human expert who can make the right improvements
            </ModalSubText>
          </ModalHeader>
        </KitModalHeader>

        <div class="tw-flex tw-flex-col tw-gap-6">
          <span class="tw-flex tw-gap-3 tw-text-neutral-900 tw-font-bold tw-text-2xl tw-leading-none">
            <FixPanelIcon icon-path="icons/users-talking" />
            What feedback should I pass to my manager?
          </span>

          <ModalTextAreaWrapper>
            <div>
              <textarea
                v-model="feedback"
                :placeholder="`For Example:

I've been trying to get ${kitName} to revise the content to have a more conversational tone, but it's not quite using the right tone for my website`"
                rows="8"
                class="tw-w-full tw-text-neutral-900 tw-text-base tw-resize-none"
              />
            </div>
            <p
              v-if="validationError"
              class="tw-text-danger"
            >
              {{ validationError }}
            </p>
          </ModalTextAreaWrapper>
        </div>

        <div class="tw-flex tw-items-center tw-gap-4 tw-self-end">
          <DefaultButton
            variant="primary-inverted"
            :disabled="isPending"
            @click="emit('close')"
          >
            Cancel
          </DefaultButton>
          <DefaultButton
            :disabled="isPending"
            :d
            @click="triggerHelp"
          >
            Continue
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>
